import React from 'react'
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import { template2PreviewData } from '../../lib/TemplatesData';
import { ensureUrlProtocol } from '../../lib/util';

const Template2 = () => {
    let formData = localStorage.getItem("formData");
    formData = formData !== null ? JSON.parse(formData) : template2PreviewData;
    const iconStyle = { fontSize: '15px', marginTop: '3px', marginRight: '3px' };

    const { firstName = '', lastName = '', email = '', phone = '', links = [], Experience = [], Education = [], Skills = [], Projects = [], Achievements = [], courses = [] } = formData;
    let taggedSkillsObject = {
        'Languages': [],
        'Tools': [],
        'Framework & Library': [],
        'Technologies': []
    };

    Skills.forEach((item) => {
        const { skill = '', level = '', tag = '' } = item;
        if (tag && taggedSkillsObject[tag]) {

            taggedSkillsObject[tag] = [...taggedSkillsObject[tag], { skill, level }]

        }
    })
    return (
        <div>
            <div className='flex items-center flex-col w-full'>
                {/* {Header} */}
                <div className='border-b-2 py-2 flex flex-col justify-center items-center w-full'>
                    <div className='text-5xl mt-2 mb-1 text-neutral-500'><span className='text-neutral-400 font-light '>{firstName}</span> {lastName}</div>
                    <div className='flex text-neutral-400 font-medium '>
                    <a href={`mailto:${email}`} className=''>{email}</a>
                        {email !== '' && phone !== '' && <div className='mx-1'>|</div>}
                        <div>{phone}</div>
                    </div>
                </div>
                <div className='grid grid-cols-5 w-full px-8 py-4 gap-0'>
                    {/* Left */}
                    <div className='col-span-2'>
                        {/* Education */}
                        {
                            Education.length > 0 && <div>
                                <div className='text-black/50 text-xl'>EDUCATION</div>
                                {Education.map((item, index) => {
                                    const { degree = '', college = '', city = '', endDate = '' } = item;

                                    return <div key={index}>
                                        <div className='text-black/90 font-bold'>{college}</div>
                                        <div className='text-black/80 font-medium'>{degree}</div>
                                        <div className='text-black/50 font-semibold text-sm'>
                                            {endDate} | {city}
                                        </div>
                                    </div>
                                })}
                            </div>
                        }
                        {/* Links */}
                        {links.length > 0 && <div className='my-3'>
                            <div className='text-black/50 text-xl'>LINKS</div>
                            {links.map((item, index) => {
                                const { label = '', link = '' } = item;
                                const formattedLink = ensureUrlProtocol(link)

                                let domain = link.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('.')[0];
                                domain = domain.charAt(0).toUpperCase() + domain.slice(1);
                                return <div className='flex mt-1 text-sm'>
                                    <div className='text-black/50 font-semibold pr-1'>{domain}:// </div>   <a className='text-black/80  font-medium' href={formattedLink} target='_blank' rel="noreferrer">{label}</a>
                                </div>
                            })}
                        </div>}
                        {/* Skills */}
                        {Skills.length > 0 && <div className='max-w-60'>
                            <div className='text-black/50 text-xl '>SKILLS</div>
                            {
                                Object.keys(taggedSkillsObject).map((item) => {
                                    return <div className='mt-2'>
                                        {taggedSkillsObject[item].length > 0 && <div className='text-black/80 font-bold'>{item}</div>}

                                        <div className='flex flex-wrap gap-x-4 gap-y-1'>
                                            {taggedSkillsObject[item].map((item) => {
                                                const { skill = '', level = '' } = item;

                                                return skill && <div className=''>
                                                    <li className='pr-1'>{level && <span className='text-black/50 font-semibold'>{level}:</span>} <span className='text-black/80 font-semibold'>{skill}</span> </li>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                })
                            }
                        </div>}
                        {
                            Achievements.length > 0 && <div className='max-w-64'>
                                <div className='text-black/50 text-xl mt-3'>Achievements</div>
                                {Achievements.map((item) => {
                                    const { rank = '', competition = '' } = item;
                                    return <div className='flex justify-between text-black/80 font-semibold mt-1'>
                                        <div>
                                            {rank}
                                        </div>
                                        <div className='flex flex-wrap text-right'>{competition}</div>
                                    </div>
                                })}
                            </div>
                        }
                        {
                            courses.length > 0 && <div className='max-w-72'>
                                <div className='text-black/50 text-xl mt-3'>CourseWork</div>
                                {courses.map((item) => {
                                    const { course = '', link = '' } = item;
                                    const formattedLink = ensureUrlProtocol(link)

                                    return <div className='mt-1'><a href={formattedLink} target='_blank' rel="noreferrer" className='text-black/80 font-semibold'>{course}</a></div>
                                })}
                            </div>
                        }
                    </div>

                    {/* Right */}
                    <div className='col-span-3'>
                        {/* Experience */}

                        {Experience.length > 0 && <div>
                            <div className='text-black/50 text-xl'>EXPERIENCE</div>
                            {Experience.map((item, index) => {
                                const { employer = '', jobTitle = '', city = '', desc = '', startDate = '', endDate = '' } = item;

                                return <div>
                                    <div className='flex items-center'>
                                        <span className='text-black/90 font-bold'>{employer}</span> <span className='mx-1 text-black/50 font-bold'>|</span> <span className='text-black/80 font-medium'>{jobTitle}</span>

                                    </div>
                                    <div className='flex items-center text-black/50 font-semibold text-sm mt-1'>
                                        <span>{startDate}</span> <span className='mx-1'>-</span> <span>{endDate}</span> <span className='mx-1'>|</span> <span>{city}</span>
                                    </div>
                                    <div className='px-3'> {desc !== '' && <div
                                        dangerouslySetInnerHTML={{ __html: desc }}
                                        className='exp-list'
                                    />}</div>
                                </div>
                            })}

                        </div>}
                        {/* Projects */}
                        {Projects.length > 0 && <div>
                            <div className='text-black/50 text-xl'>Projects</div>
                            {Projects.map((item, index) => {
                                const { title = '', techStack = '', link = '', desc = '', sourceCode = '' } = item;
                                const formattedLink = ensureUrlProtocol(link)
                                const formattedSoruceCodeLink = ensureUrlProtocol(sourceCode)


                                return <div>
                                    <div className=''>
                                        <div className='flex justify-between items-center'>
                                            <div className='text-black/90 font-bold'>{title}</div>
                                            <div className='text-xs w-fit flex items-center'>
                                                {sourceCode !== '' && <a href={formattedSoruceCodeLink} target='_blank' rel="noreferrer">Source Code</a>}
                                                {sourceCode !== '' && link !== '' && <span className='mx-1'>|</span>}
                                                {link !== '' && <a className='flex' href={formattedLink} target='_blank' rel="noreferrer">Project Link <FaArrowUpRightFromSquare className='ml-1' size={12} style={iconStyle} /></a>}
                                            </div>
                                        </div>
                                        <div className='text-black/50 font-semibold text-xs'>Tech Stack: {techStack}</div>
                                        <div className='px-3'> {desc !== '' && <div
                                            dangerouslySetInnerHTML={{ __html: desc }}
                                            className='project-list'
                                        />} </div>
                                    </div>
                                </div>
                            })}
                        </div>}
                    </div>
                </div>


            </div>
        </div>
    )
}

export default Template2